import path from "path-browserify"; // can't use "path" because we're not running in Node.js

export interface OptionInfo {
  label: string;
  pathIgnore: string;
}

export const generatePathIgnoreOptions = (filePath: string) => {
  // working with a file path without the trailing slash because that makes things easier
  const normalizedFilePath = filePath.startsWith("/")
    ? filePath.slice(1)
    : filePath;
  const pathParts = normalizedFilePath.split("/");
  // adding trailing slash in for the parsed parts so the pathIgnore starts with a slash
  const { dir, base } = path.parse("/" + normalizedFilePath);

  const pathOptions: string[] = [];
  if (pathParts.length === 1) {
    pathOptions.push();
  }

  const ignoreOptions: { [key: string]: OptionInfo } = {
    currentFile: {
      label: base,
      pathIgnore: "/" + normalizedFilePath,
    },
  };

  const currDirName = pathParts.slice(-2, -1);
  if (pathParts.length > 1) {
    const dirDisplayStr = `/${currDirName[0]}/*`;
    ignoreOptions["currentDirectory"] = {
      label: dirDisplayStr,
      pathIgnore: dir + "/",
    };
  }

  const parentName = pathParts.slice(-3, -2);
  if (pathParts.length > 2) {
    const parentDisplayStr = `/${parentName[0]}/*`;
    ignoreOptions["parentDirectory"] = {
      label: parentDisplayStr,
      // get the directory that the current directory is in
      pathIgnore: path.parse(dir).dir + "/",
    };
  }
  return ignoreOptions;
};
